// extracted by mini-css-extract-plugin
export default {"back":"ChartsBackLink_back__d92b-"};